import React, { useState, useEffect, useCallback } from "react";
import { NavLink } from "react-router-dom";
import Paging from "../../component/Paging";
import request from '../../../utils/Request.utils';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from '../../component/DatePicker';

const formatDate = (date) => {
  if (!date) return '-';

  const parsedDate = new Date(date);
  return Number.isNaN(parsedDate.getTime()) ? '-' : parsedDate.toLocaleDateString();
};

const MemberLeave = () => {
  const [users, setUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currPage, setCurrPage] = useState(1);
  const [totalCnt, setTotalCnt] = useState(0);
  const [loading, setLoading] = useState(true);

  // 검색
  const [searchQuery, setSearchQuery] = useState('');
  const [inputQuery, setInputQuery] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const todayDate = moment().format('YYYY-MM-DD'); // 미래 날짜 선택 차단 기준

  const successHandler = useCallback((response) => {
    if (response.messageCode === 200) {
      setUsers(response.data.dataList || []);
      setTotalPages(response.data.tot_page || 1);
      setTotalCnt(response.data.totalCnt || 0);
      setLoading(false);
    } else {
      toast.error("회원 정보를 불러올 수 없습니다.");
      setLoading(false);
    }
  }, []);

  const errorHandler = useCallback((error) => {
    toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
    setLoading(false);
  }, []);

  const fetchUsers = useCallback(() => {
    setLoading(true);
    const params = {
      curr_page: currPage,
      per_page: 10,
      sort_col: 'reg_dtm',
      sort_by: 'desc',
      user_stat: 'US90',
      search_query: searchQuery,
      search_start_date: searchStartDate,
      search_end_date: searchEndDate,
    };
    request.get("/user/list", params, successHandler, errorHandler);
  }, [currPage, searchQuery, searchStartDate, searchEndDate, successHandler, errorHandler]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handlePageChange = (page) => {
    setCurrPage(page);
  };

  const handleSearch = () => {
    setCurrPage(1);
    setSearchQuery(inputQuery.trim());
  };

  const handleReset = () => {
    setInputQuery('');
    setSearchQuery('');
    setSearchStartDate('');
    setSearchEndDate('');
    setCurrPage(1);
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">탈퇴 회원 관리</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_board_list__top">
          <div className="adm_com_board_search">
            <div className="adm_com_input_wrap flex_row">
              <span className="tit">가입일 : </span>
              <DatePicker
                value={searchStartDate}
                max={searchEndDate || todayDate}
                onChange={setSearchStartDate}
              />
              <span className="divider"> ~ </span>
              <DatePicker
                value={searchEndDate}
                min={searchStartDate || undefined}
                max={todayDate}
                onChange={setSearchEndDate}
              />
            </div>
            <article className="search end">
              <select className="select">
                <option value="전체">전체</option>
              </select>
              <input
                type="search"
                value={inputQuery}
                onChange={(e) => setInputQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleSearch();
                }}
                placeholder="검색할 내용을 입력해 주세요."
                className="input ws type_search"
              />
              <button className="adm_com_btn blue" onClick={handleSearch}>조회</button>
              <button className="adm_com_btn gray" onClick={handleReset}>초기화</button>
            </article>
          </div>
        </div>
        <div className="adm_com_btn_wrap">
          <span>총 {totalCnt}명</span>
        </div>
        {loading ? null : (
          <table className="adm_com_board_list">
            <colgroup>
              <col width="5%" />
              <col width="10%" />
              <col width="15%" />
              <col width="15%" />
              <col width="20%" />
              <col width="10%" />
              <col width="10%" />
              <col width="5%" />
            </colgroup>
            <thead>
              <tr>
                <th>번호</th>
                <th>회원번호</th>
                <th>아이디</th>
                {/* <th>이름</th>
                <th>닉네임</th> */}
                <th>휴대폰</th>
                <th>이메일</th>
                <th>가입일</th>
                <th>최근접속일</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user, index) => (
                  <tr key={user.user_seq}>
                    <td>{totalCnt - ((currPage - 1) * 10 + index)}</td>
                    <td>{user.user_seq}</td>
                    <td>{user.user_id}</td>
                    {/* <td>{user.user_name || 'N/A'}</td>
                  <td>{user.user_nickname || 'N/A'}</td> */}
                    <td>{user.user_phone}</td>
                    <td>{user.user_email}</td>
                    <td>{formatDate(user.reg_dtm)}</td>
                    <td>{formatDate(user.last_login_dt)}</td>
                    <td>
                      <NavLink
                        to={`/Member/MemberLeave/Detail/${user.user_seq}`}
                        className="adm_com_btn blue line"
                      >
                        상세
                      </NavLink>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">탈퇴 회원이 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
        <Paging
          currentPage={currPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      <ToastContainer />
    </main>
  );
};

export default MemberLeave;
